export const getHashtagUrl = (sectionUrl: string, hashtag: string) =>
  `${sectionUrl}/hashtags/${hashtag}`;
